<template>
	<div class="pintuan">
		<div class="head">
			<div class="search-input">
				<nut-icon size="15px" type="search"></nut-icon>
				<input type="text" placeholder="请输入您想报名的驾校" v-model="searchValue" @keyup.enter="submit" />
				<div @click="clearInput" class="search-input-icon">
					<nut-icon
						size="15px"
						v-if="searchValue"
						type="circle-cross"
					></nut-icon>
				</div>
			</div>
			<!-- <nut-searchbar
				v-model="searchValue"
				placeText="请输入您想报名的驾校"
				:hasIcon="true"
				:hasSearchButton="false"
				customClass="search"
				@blur="search_store"
			></nut-searchbar> -->

			<ul class="navtab">
				<li
					v-for="(item, index) in navData"
					:key="index"
					class="navtab-item"
					:class="{ checked: index === navIndex }"
					@click="handleFilter(index)"
				>
					<span class="flex a-center"
						>{{ item.name }}
						<nut-icon
							class="arrow-icon"
							type="down"
							size="10px"
							v-if="index === 2"
						></nut-icon
					></span>
				</li>
			</ul>
		</div>

		<div class="body">
			<!-- @pulldown="pulldown" -->
			<nut-scroller
				:is-un-more="isUnMore"
				:is-loading="isLoading"
				:type="'vertical'"
				unloadMoreTxt = '没有更多了'
				@loadMore="loadMoreVert"
				@pulldown="pulldown"
			>
				<div slot="list" class="nut-vert-list-panel">
					<div
						class="nut-vert-list-item"
						style="min-height: 40px;"
						v-for="(item, index) in listData"
						:key="index"
					>
						<div
							class="pintuan-item"
							:key="index"
							@click="handleClick(item.id)"
						>
							<PintuanItem :borderBottom="true" :data="item" />
						</div>
					</div>
          <div style="width: 100%;height: 60px;"></div>
				</div>

			</nut-scroller>
		</div>

		<div v-show="expended" class="popup" @click.self="expended = false">
			<div style="background: #fff">
				<Driving @choose="chooseType" />
			</div>
		</div>
	</div>
</template>

<script>
import PintuanItem from '@/components/PintuanItem.vue'
import Driving from '@/components/Driving.vue'
var store_name,
	cat_id1 = ''
var order = 'def'
export default {
	name: 'pintuan-list',
	components: {
		PintuanItem,
		Driving,
	},
	data: () => ({
		searchValue: '',
		navData: [
			{ name: '推荐', id: 'def', checked: false },
			// { name: '距离', id: "f.group_price", checked: false },
			{ name: '价格', id: 'f.group_price', checked: false },
			{ name: '驾考类型', id: 3, checked: false },
		],
		navIndex: 0,
		// 列表
		listData: new Array(5),
		isUnMore: false,
		isLoading: false,
		page: 1,
		maxPages: 600,

		// 驾照类型展开
		expended: false,
	}),
	created() {
		this.listData = []
		this.getTeamList()
	},
	methods: {
		handleFilter(index) {
			this.listData = []
			this.navIndex = index
			const { id } = this.navData[this.navIndex]

			if (id && id == 3) {
				this.expended = !this.expended
				if (!this.expended) {
					this.navIndex = -1
				}
			} else {
				order = id
				cat_id1 = ''
				this.getTeamList()
				this.expended = false
			}
		},
		getTeamList() {
			this.$ajax
				.get('/m/team/index', {
					activity_id: this.$ajax.get_activity_id(),
					store_name: this.searchValue,
					order: order,
					cat_id1: cat_id1,
					//page_size: this.pageSize,
					page: this.page,
				})
				.then((res) => {
					this.isLoading = false
					this.pageSize = 10
					if (res && res.length) {
						//this.listData = res;
						if (this.page = 1 && res.length < 15) {
							this.isUnMore = true
						} else if (this.page > 1 && res.length < 10) {
							this.isUnMore = true
						} else {
							this.isUnMore = false
						}

					} else {
						this.isUnMore = true
						//this.listData = res;
					}
					if (this.listData) {
						this.listData = this.listData.concat(res)
					} else {
						this.listData = res
					}
				})
		},
		search_store() {
			this.getTeamList()
		},
		// 选择驾照类型
		chooseType(value) {
			cat_id1 = value.id
			this.getTeamList()
			this.navIndex = -1
			this.expended = false
		},
		// 查看拼团详情
		handleClick(id) {
			this.$router.push({
				name: 'ClassTypeDetail',
				query: { team_detail_id: id },
			})
		},
		// 上拉
		loadMoreVert() {
			this.isLoading = true
			if (this.page >= this.maxPages) {
				this.isUnMore = true
				this.isLoading = false
			} else {
				this.page++
				// this.isUnMore = false;
				// this.isLoading = false;
				this.getTeamList()
			}
		},
		// 下拉
		pulldown() {
			this.isLoading = true
			this.isUnMore = false
			this.page = 1
			this.listData = []
			this.getTeamList()
		},
		submit() {
			this.listData = []
			this.page = 1
			this.getTeamList()
		},
		clearInput() {
			this.searchValue = ''
			this.listData = []
			this.page = 1
			this.getTeamList()
		},
	},
}
</script>

<style lang="less" scoped>
.pintuan {
	display: flex;
	flex-direction: column;
	height: 100vh;
	/deep/ .nut-icon-search svg {
		fill: #999999;
	}
	.head {
		flex-shrink: 0;
		text-align: center;
		.search {
			margin: 10px 14px;
		}
		.search-input {
			width: 92%;
			height: 30px;
			margin-left: 10px;
			align-items: center;
			background-color: #f6f6f6;
			border-radius: 20px;
			padding: 0 10px;
			margin-top: 10px;
			margin-bottom: 10px;
			display: flex;
			flex-direction: row;
			justify-content: center;

			input {
				border: none;
				outline: none;
				flex: 1;
				height: 30px;
				background-color: #f6f6f6;
				padding-left: 15px;
				padding-right: 15px;
			}
			.search-input-icon {
				display: flex;
				align-items: center;
				justify-content: center;
			}
		}
		.navtab {
			font-size: 0;
			border-bottom: 1px solid #e2e2e2;
			padding-bottom: 10px;
			padding-left: 14px;
			padding-right: 14px;
			text-align: left;
			&-item {
				display: inline-block;
				color: #999999;
				font-size: 14px;

				margin-right: 30px;
			}
			&-item.checked {
				color: #333333;
				font-weight: bold;
				.arrow-icon {
					transform: rotate(180deg);
				}
			}
			.arrow-icon {
				transition: all 0.3s ease-in-out;
				margin-left: 5px;
			}
		}
	}
	.body {
		// flex-grow: 1;
		height: calc(100% - 90px);
		.pintuan-item {
			padding: 10px 14px;
      .flex{
        padding-bottom: 15px;
        margin-bottom: 15px;
        border-bottom: 1px solid #eae8e8;
      }
		}
	}

	.popup {
		position: absolute;
		left: 0;
		top: 89px;
		z-index: 88;
		width: 100%;
		height: calc(100% - 90px);
		background: rgba(0, 0, 0, 0.2);
	}
}

/deep/ .nut-searchbar .search-input {
	margin-right: 0;
}
/deep/ .nut-vert-list-panel {
	// height: 100vh;
}
</style>
